exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".descoration{cursor:pointer}", "", {"version":3,"sources":["/vercel/path0/src/pages/InitialContract.vue"],"names":[],"mappings":"AACA,aACI,cAAgB,CACnB","file":"InitialContract.vue","sourcesContent":["\n.descoration {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71e31110","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/InitialContract.vue
// module id = 631
// module chunks = 4